import React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

interface Props {
  children: React.ReactNode
}

export const FormSection = ({ children }: Props) => {
  return (
    <Box
      background="grey200"
      borderRadius={{
        all: 'abs008',
      }}
      padding="s24"
      gap="s16"
    >
      {children}
    </Box>
  )
}
